var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1465 16.8539C14.6451 18.1891 12.6673 19.0002 10.5 19.0002C5.80558 19.0002 2 15.1947 2 10.5002C2 5.80582 5.80558 2.00024 10.5 2.00024C15.1944 2.00024 19 5.80582 19 10.5002C19 12.6675 18.1889 14.6454 16.8536 16.1468L22.3535 21.6467C22.5488 21.8419 22.5488 22.1585 22.3535 22.3538C22.1583 22.549 21.8417 22.549 21.6464 22.3538L16.1465 16.8539ZM18 10.5002C18 14.6424 14.6421 18.0002 10.5 18.0002C6.35786 18.0002 3 14.6424 3 10.5002C3 6.35811 6.35786 3.00024 10.5 3.00024C14.6421 3.00024 18 6.35811 18 10.5002Z",
    fill: "#2C3D50",
    stroke: "#2C3D50",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/input-search.09b4d5e1042f1bb1dcc2b30b357eecd3.svg";
export { ForwardRef as ReactComponent };